export const categories = [
    { name: "produce" },
    { name: "protein" },
    { name: "dairy" },
    { name: "grain" },
    { name: "other" }
  ];


